import { Box } from "@mui/material";
import { CookieConsentBanner } from "shared/feedback/CookieConsentBanner";
import { MarketNoticeDialog } from "shared/feedback/MarketNoticeDialog";
import { SiteHeader } from "shared/layout/SiteHeader";
import { findRouteByPathname, publicRoutes } from "app/router/public/routes";
import { useShellNavigation } from "app/router/public/useShellNavigation";
import { Outlet, useLocation } from "react-router";
import { SiteFooter } from "shared/layout/SiteFooter";

export function PublicLayout() {
  const location = useLocation();
  const { siteFooterProps, siteHeaderProps } = useShellNavigation();
  const currentRoute = findRouteByPathname(location.pathname);
  const hasOverlayHeader = Boolean(currentRoute?.overlayHeader);
  const isHomeRoute = location.pathname === publicRoutes.home.path;

  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "var(--oxy-surface)" }}>
      <SiteHeader
        enableScrollEffect={hasOverlayHeader}
        deferBrandLogoUntilScrolled={hasOverlayHeader}
        hideBrandLogoUntilScrolled={isHomeRoute}
        {...siteHeaderProps}
      />

      <Box sx={{ pt: hasOverlayHeader ? 0 : { xs: "88px", lg: "104px" } }}>
        <Outlet />
        <SiteFooter {...siteFooterProps} />
      </Box>

      <CookieConsentBanner />
      <MarketNoticeDialog />
    </Box>
  );
}
